import Vue from 'vue';
import {
    CreatePorterCommandArguments, IPorterViewModel, IPorterFieldListViewModel, IPorterListViewModel, GenericFieldDescription, PorterViewModel
} from 'Api/CoreApi';
import Component from 'vue-class-component';
import ABaseComponent from 'Components/Base/ABaseComponent';
import ApiProvider from 'Api/ApiProvider';
import PorterValidation from '../PorterValidation/PorterValidation';
import { Prop } from 'vue-property-decorator';

@Component({ validations: PorterValidation })
export class PorterCreateComponent extends ABaseComponent {
    @Prop()
    porterUrl: string;

    @Prop()
    public customerUsesFunctions: boolean;

    public functionCodes: string[] = [];
    public selectedFunctionCode: string = "";

    @Prop()
    public customerNo: string;

    //public savedPorter: PorterViewModel;


    public porter: IPorterViewModel = {
        firstName: '',
        lastName: '',
        email: '',
        genericFields: {}
    };
    public porterList: IPorterListViewModel = { porters: [] }
    public search: string = '';
    public saved: boolean = false;
    async created() {
        this.setLoading();

        const client = ApiProvider.getApiClient();
        client.getOrganizationPorters()
            .then(result => {
                this.porterList = result;
                this.porter.genericFields = this.mapToObject(this.porterList.fields);//sets available fields on the VM
                this.setLoaded();
            })
            .catch(e => {
                this.setError(e);
            });

        if (this.customerUsesFunctions) {
            client.getPorterFunction(this.customerNo)
                .then(porterFunctionData => {
                    this.functionCodes = porterFunctionData.functions;
                });
        }
    }

    get requireEmail(): boolean {
        return ("Email" in this.porter.genericFields)
    }

    gotoLink(porterModel: IPorterViewModel, basePath: string) {
        location.href = basePath
            + (basePath.indexOf('?') > -1 ? '&' : '?')
            + 'porterId='
            + porterModel.id;
    }
    mapToObject(genericFields: GenericFieldDescription[]): { [key: string]: any } {
        let actualFields: { [key: string]: any } = {};
        for (let i = 0; i < genericFields.length; i++) {
            actualFields[genericFields[i].key] = '';
        }
        return actualFields;
    }
    save() {
        this.setLoading();

        const args = new CreatePorterCommandArguments({
            firstName: this.porter.firstName,
            lastName: this.porter.lastName,
            nonDismissable: false,
            city: this.porter.city,
            street: this.porter.street,
            email: this.porter.email,
            functionCode: this.selectedFunctionCode,
            genericFields: this.porter.genericFields
        });

        this.$v.$touch();

        if (!this.$v.$invalid) {
            const client = ApiProvider.getApiClient();
            client.createPorter(args)
                .then(() => {
                    // reset porter upon save
                    this.porter = {
                        firstName: '',
                        lastName: '',
                        email: '',
                        genericFields: {}
                    };

                    // Reset validation
                    this.$v.$reset();

                    this.saved = true;

                    window.location.replace(this.porterUrl);
                    this.setLoaded();
                })
                .catch(e => {
                    this.setError(e);
                });

        }

        this.setLoaded();

    }

    get portersFiltered() {
        this.search = this.porter.firstName + this.porter.lastName;

        if (!this.search) return false;

        var result = this.porterList.porters.filter(searchPorter => {
            return searchPorter.firstName.toLowerCase().indexOf(this.porter.firstName.toLowerCase()) > -1 &&
                searchPorter.lastName.toLowerCase().indexOf(this.porter.lastName.toLowerCase()) > -1;
        });


        if (result.length > 0) return result;
    }
}

Vue.component('porter-create', PorterCreateComponent);
